import * as ActionTypes from '../ActionTypes';

export const GetLetterHeadAction = (params) => {
    return {
        type: ActionTypes.LETTER_HEAD_GET_REQUEST,
        params
    }
}

export const UpdateLetterHeadAction = (params) => {
    return {
        type: ActionTypes.LETTER_HEAD_UPDATE_REQUEST,
        params
    }
}

export const GetCompanyLogoAction = (params) => {
    return {
        type: ActionTypes.COMPANY_LOGO_GET_REQUEST,
        params
    }
}

export const UpdateCompanyLogoAction = (params) => {
    return {
        type: ActionTypes.COMPANY_LOGO_UPDATE_REQUEST,
        params
    }
}